import { IconEyeOff as TablerIconEyeOff } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconEyeOff = /*#__PURE__*/ createOutlineIcon(TablerIconEyeOff, 'IconEyeOff');
